import { useCallback } from 'react';
import { api } from './api';
import { useApiQuery } from './useApiQuery';

/**
 * `pollMs` matters here in a way it doesn't on most surfaces: intake state
 * changes with no user action at all — a forwarded PDF lands, parses, and its
 * row moves through pending -> parsed/failed while the PM is just looking at
 * the page. Without a poll, "N PDFs still processing" would freeze at whatever
 * it read on mount, which is worse than not showing it. Off by default so
 * existing callers are unchanged.
 */
export function useIntakeHealth(days = 7, pollMs?: number) {
  const fetcher = useCallback(
    (token: string, signal: AbortSignal) => api.intake.health(token, days, { signal }),
    [days],
  );
  return useApiQuery(fetcher, [days], pollMs ? { pollMs } : {});
}
